import '@pa/ui/styles/index.css'
import '@pa/ui/styles/staff.css'
import { boot } from './boot'

const container = document.getElementById('root')
if (!container) throw new Error('#root is missing from index.html')
void boot(import.meta.env, container)
